/**
 * Test IDs for QA automation.
 */
export const testIds = {
  assignmentModalDriverPicker: "assignment-modal-driver-picker",
  assignmentModalDriverSearch: "assignment-modal-driver-search",
  assignmentModalTractorPicker: "assignment-modal-tractor-picker",
  assignmentModalTractorSearch: "assignment-modal-tractor-search",
  assignmentModalTrailerPicker: "assignment-modal-trailer-picker",
  assignmentModalTrailerSearch: "assignment-modal-trailer-search",
  assignmentModalAssetsPupTrailersManyPicker: "assignment-modal-assets-pup-trailers-many-picker",
  assignmentModalAssetsPupTrailersManySearch: "assignment-modal-assets-pup-trailers-many-search",
  assignmentModalCancel: "assignment-modal-cancel",
  assignmentModalValidate: "assignment-modal-validate",
} as const;
